import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { SvgIconProps, lighten } from '@mui/material';

import { Typography } from '../Typography';
import { Button } from '../Button';

export interface SidebarTopNavigationItemProps {
  isActive: boolean;
  linkTo: string;
  title: string;
  Icon: React.ComponentType<SvgIconProps>;
}

export const SidebarTopNavigationItem: React.FC<SidebarTopNavigationItemProps> = ({
  title,
  Icon,
  isActive,
  linkTo,
}) => {
  return (
    <Button
      data-testid={title}
      sx={(theme) => ({
        py: 2,
        justifyContent: 'start',
        borderRadius: 2,
        letterSpacing: 0,
        background: isActive ? lighten(theme.palette.primary.main, 0.9) : null,
        my: 0.5,
        '&:hover': {
          background: isActive
            ? lighten(theme.palette.primary.main, 0.9)
            : lighten(theme.palette.background.default, 0.5),
          cursor: isActive ? 'default' : 'pointer',
        },
      })}
      component={RouterLink}
      to={linkTo}
    >
      <Icon fontSize='small' sx={{ mr: 2, color: isActive ? 'primary.main' : 'text.disabled' }} />
      <Typography
        color={isActive ? 'primary.main' : 'text.secondary'}
        textTransform='none'
        component='span'
        fontWeight={isActive ? 700 : 500}
      >
        {title}
      </Typography>
    </Button>
  );
};
